import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";

import * as actions from "../../redux/actions/index";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import prettyAddress from "../../util/prettyAddress";
import copyShareUrl from "../../util/copyShareUrl";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
    createStyles({
        iconButtonHideForSmall: {
            display: "none",
            [theme.breakpoints.up("sm")]: {
                display: "inline-flex",
            },
        },
    })
);

export default function CorporateListingsList(props) {
    // Setup what we need from Redux
    const listings = useSelector((state) => state.listings.listings);
    const currentPage = useSelector((state) => state.listings.currentPage);
    const dispatch = useDispatch();
    // MaterialUI theme classes
    const classes = useStyles();
    // Start building the component code that will get returned.
    let listingsList;
    if (listings === null) {
        // The app hasn't loaded any listing data yet, so show placeholder listing items.
        // The loading/error status is handled by the main AllListings file where this is imported.
        listingsList = [];
        for (let i = 0; i < 10; i++) {
            listingsList[i] = (
                <ListItem button key={i}>
                    <ListItemIcon>
                        <VisibilityOffIcon color="disabled" />
                    </ListItemIcon>
                    <ListItemText
                        primary="Loading&hellip;"
                        secondary="Loading&hellip;"
                    />
                </ListItem>
            );
        }
    } else if (listings[currentPage].length === 0) {
        // An account can have 0 listings, so we need to handle showing a message for this case instead of trying to loop through all listings.
        listingsList = (
            <ListItem button key={0}>
                <ListItemText primary="There are currently no listings to show for this account." />
            </ListItem>
        );
    } else {
        listingsList = listings[currentPage].map((listing) => {
            let commentsInspectionsString;
            if (listing.commentcount && listing.commentcount > 0) {
                if (listing.commentcount === 1) {
                    commentsInspectionsString = "1 comment";
                } else {
                    commentsInspectionsString = `${listing.commentcount} comments`;
                }
            } else {
                commentsInspectionsString = "0 comments";
            }
            let listingAddress = prettyAddress(listing);
            const publishedIcon = listing.dashboard.published ? (
                <VisibilityIcon color="primary" titleAccess="Published" />
            ) : (
                <VisibilityOffIcon color="disabled" titleAccess="Unpublished" />
            );
            return (
                <ListItem button key={listing?.listonce_id}>
                    <ListItemIcon>{publishedIcon}</ListItemIcon>
                    <ListItemText
                        primary={<Typography variant="subtitle2" style={{color: "black", lineHeight: 1}}>{listingAddress}</Typography>}
                        secondary={<Typography variant="subtitle1" style={{lineHeight: 1}} >{commentsInspectionsString}</Typography>}
                    />
                    {listing.dashboard.published ? (
                        <ListItemSecondaryAction>
                            <IconButton
                                className={classes.iconButtonHideForSmall}
                                aria-label="comments"
                                onClick={() =>
                                    copyShareUrl(
                                        listing.dashboard.public_dashboard_url_v2,
                                        (message, severity) =>
                                            dispatch(
                                                actions.showSnackbar(
                                                    message,
                                                    severity
                                                )
                                            )
                                    )
                                }
                            >
                                <FileCopyOutlinedIcon
                                    color="primary"
                                    titleAccess="Copy Public Report URL"
                                />
                            </IconButton>
                            <Link
                                href={`/dashboard/listing/${listing?.dashboard?.ekey}/${listing?.listonce_id}`}
                                target="_blank"
                            >
                                <IconButton edge="end" aria-label="comments">
                                    <OpenInNewIcon
                                        color="primary"
                                        titleAccess="View Public Report"
                                    />
                                </IconButton>
                            </Link>
                        </ListItemSecondaryAction>
                    ) : null}
                </ListItem>
            );
        });
    }

    return (
        <List component="nav" aria-label="secondary mailbox folders">
            {listingsList}
        </List>
    );
}